import React, { useEffect } from 'react';
import Breadcrumb from '../../components/admin/Breadcrumb';
import AdminDashboard from '../../components/dashboard/AdminDashboard';
import OperationsDashboard from '../../components/dashboard/OperationsDashboard';
import VendorDashboard from '../../components/dashboard/VendorDashboard';
import { useAuth } from '../../context/AuthContext';
import { isAdmin, isOperation, isVendor } from '../../config/rbac';
import posthog from 'posthog-js';

// Enhanced Dashboard component with role-based content
const Dashboard: React.FC = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (posthog.__loaded) {
      const userRole = user?.groups?.[0] || 'unknown';
      posthog.capture('dashboard_viewed', {
        user_role: userRole,
        component: 'Dashboard',
      });
    }
  }, [user]);

  const renderDashboardContent = () => {
    if (isAdmin(user)) {
      return <AdminDashboard />;
    } else if (isOperation(user)) {
      return <OperationsDashboard />;
    } else if (isVendor(user)) {
      return <VendorDashboard />;
    } else {
      // Fallback for unknown roles
      return (
        <div className="rounded-sm border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark">
          <div className="text-center">
            <svg className="w-16 h-16 mx-auto text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5Z" />
            </svg>
            <h3 className="text-lg font-semibold text-black dark:text-white mb-2">
              Access Restricted
            </h3>
            <p className="text-meta-6">
              Your account doesn't have the necessary permissions to view this dashboard.
              Please contact your administrator for access.
            </p>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <Breadcrumb pageName="Dashboard" />
      <div className="mt-4 md:mt-6 2xl:mt-7.5">
        {renderDashboardContent()}
      </div>
    </>
  );
};

export default Dashboard;